import React from 'react';
import './DynaInput.scss';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import numericFunction from "../../../utils/NumericFunction";

const DynaDatePicker = (props) => {

  const svgDate = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#B9B9B9"
      d="M6.666 4.792a.63.63 0 01-.625-.625v-2.5a.63.63 0 01.625-.625.63.63 0 01.625.625v2.5a.63.63 0 01-.625.625zM13.334 4.792a.63.63 0 01-.625-.625v-2.5a.63.63 0 01.625-.625.63.63 0 01.625.625v2.5a.63.63 0 01-.625.625zM17.083 8.2H2.916a.63.63 0 01-.625-.625.63.63 0 01.625-.625h14.167a.63.63 0 01.625.625.63.63 0 01-.625.625z"
    ></path>
    <path
      fill="#B9B9B9"
      d="M13.333 18.958H6.667c-3.042 0-4.792-1.75-4.792-4.791V7.083c0-3.041 1.75-4.791 4.792-4.791h6.666c3.042 0 4.792 1.75 4.792 4.791v7.084c0 3.041-1.75 4.791-4.792 4.791zM6.667 3.542c-2.384 0-3.542 1.158-3.542 3.541v7.084c0 2.383 1.158 3.541 3.542 3.541h6.666c2.384 0 3.542-1.158 3.542-3.541V7.083c0-2.383-1.158-3.541-3.542-3.541H6.667z"
    ></path>
    <path
      fill="#B9B9B9"
      d="M7.083 12.083a.829.829 0 01-.316-.066.963.963 0 01-.275-.175.962.962 0 01-.175-.275.83.83 0 01-.067-.317c0-.217.092-.433.242-.592a.96.96 0 01.275-.175.796.796 0 01.633 0c.05.017.1.042.15.075l.125.1c.033.042.075.084.1.125.033.05.058.1.075.15.025.05.042.1.05.15.008.059.017.109.017.167a.876.876 0 01-.242.592.876.876 0 01-.592.241zM10 12.083a.876.876 0 01-.592-.241 121.54 121.54 0 00-.1-.125.631.631 0 01-.075-.15.53.53 0 01-.05-.15c-.009-.059-.017-.109-.017-.167a.83.83 0 01.067-.317c.041-.1.1-.191.175-.275a.835.835 0 01.908-.175.86.86 0 01.275.175c.15.159.242.375.242.592 0 .058-.009.108-.017.167a.529.529 0 01-.05.15.634.634 0 01-.075.15l-.1.125a.86.86 0 01-.275.175.83.83 0 01-.317.066zM7.083 15a.829.829 0 01-.316-.067.96.96 0 01-.275-.175.86.86 0 01-.175-.275.83.83 0 01-.067-.316c0-.217.092-.434.242-.592a.963.963 0 01.275-.175.832.832 0 01.908.175c.033.042.075.083.1.125.033.05.058.1.075.15.025.05.042.1.05.158.008.05.017.109.017.159a.876.876 0 01-.242.591.876.876 0 01-.592.242z"
    ></path>
  </svg>

  const onChangeHandler = (date) => {
    const key = props.name
    props.setDataFromComponent({ [key]: date ? numericFunction.p2e(date.toLocaleString()) : "" })
  }

  try {
    return (
      <div className={`main-dyna-input ${props.className !== undefined ? props.className : ""}`}>
        <label htmlFor={props.name}>{props.label}</label>
        <DatePicker
          onChange={(e) => onChangeHandler(e)}
          value={props.value}
          calendar={persian}
          maxDate={props.maxDate}
          placeholder="تاریخ را انتخاب کنید"
          locale={persian_fa}
          calendarPosition="bottom-right"
          disabled={props.disabled}
          hideOnScroll
        />
        <div className={"svg-icon-side"}>
          {svgDate}
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default DynaDatePicker;